const resources = {
    via: 'via',
    kebabAltText: 'More options'
};

export default function getResource(label) {
    return resources[label];
}
